import React from 'react';
import { IconExclamation } from '@/assets/icons';
import { Button } from '@/components';

interface Props {
  goAddCard: () => void;
}

export const NoCardContent: React.FC<Props> = ({ goAddCard }) => (
  <section
    aria-labelledby="no-card-title"
    role="status"
    className="w-full mx-auto text-center px-4 py-6"
    data-testid="no-card-content"
  >
    <div className="flex flex-col items-center mx-auto max-w-sm">
      <span aria-hidden="true" className="mb-4">
        <IconExclamation height="56" className="mx-auto text-alert-warning sm:h-20" />
      </span>

      <h2
        id="no-card-title"
        className="font-dmsans font-bold text-neutro-b-400 text-lg sm:text-xl mb-2"
      >
        Você ainda não possui um cartão cadastrado
      </h2>

      <p className="font-dmsans text-base text-neutro-w-600 mb-6 max-w-[30ch] leading-relaxed">
        Para finalizar sua compra, por favor, cadastre um cartão de crédito.
      </p>

      <Button
        type="button"
        title="Adicionar cartão"
        buttonStyle="primary"
        size="lg"
        className="w-full"
        onClick={goAddCard}
        aria-label="Adicionar um novo cartão de crédito"
      />
    </div>
  </section>
);
